<template>
   <v-row no-gutters>
      <Upper />
      <v-row no-gutters class="mb-12 pt-12 mt-10" v-if="($vuetify.breakpoint.lg || $vuetify.breakpoint.md || $vuetify.breakpoint.xl)">
         <v-col cols="1" md="1" xs="1" sm="1">
         </v-col>
         <v-col cols="11" md="11" xs="11" sm="11">
            <v-row no-gutters>
               <v-col cols="1" md="1" xs="1" sm="1">
                  <!-- <v-img
          src="@/assets/Meetlogo.svg"
          max-width="500px"
          max-height="124.73px"
          class="float-center"
        ></v-img> -->
               </v-col>
               <v-col cols="6" md="6" xs="6" sm="6">
                  <!-- <v-img
          src="@/assets/Meetlogo.svg"
          max-width="200px"
          max-height="124.73px"
          class="float-right"
        ></v-img> -->
                  <!-- <div class="ml-3" style="font-size: 26px; font-weight: 500; line-height: 31.2px;">
             Anywhere Anytime
          </div> -->
                  <v-row no-gutters class="mt-12">
                     <v-col cols="12" md="12" xs="12" sm="12">
                        <div class="ml-3" style="font-size: 34px; font-weight: 500; line-height: 31.2px;">
                           {{ $t("loginpage.Mymeeting") }}
                        </div>
                        <v-row no-gutters class="mt-4">
                           <v-col cols="4" md="5" xs="4" sm="4" v-if="!chekjoin">
                              <v-menu v-if="!roomexpired">
                                 <template v-slot:activator="{ on, attrs }">
                                    <v-btn block rounded class="white--text buttonMC" color="#3D85C6" v-bind="attrs" v-on="on">
                                       <v-icon class="mr-2">mdi-video</v-icon>
                                       {{ $t("managepage.rooms") }}
                                    </v-btn>
                                 </template>
                                 <v-list>
                                    <v-list-item link @click="openModelRoomSetting">
                                       <v-list-item-icon>
                                          <v-icon>mdi-video</v-icon>
                                       </v-list-item-icon>
                                       <v-list-item-title>{{ $t("managepage.rooms") }}</v-list-item-title>
                                    </v-list-item>
                                    <v-dialog v-model="dialogA" width="500">
                                       <template v-slot:activator="{ on, attrs }">
                                          <v-list-item v-bind="attrs" v-on="on">
                                             <v-list-item-icon>
                                                <v-icon>mdi-video-plus-outline</v-icon>
                                             </v-list-item-icon>
                                             <v-list-item-title>{{ $t("loginpage.joinin") }}</v-list-item-title>
                                          </v-list-item>
                                       </template>
                                       <v-card>
                                          <v-card-title class="text-h5 grey lighten-2">
                                             {{ $t("joinpage.attendmeet") }}
                                          </v-card-title>

                                          <v-card-text>
                                             <v-row>
                                                <v-col cols="1" md="1" xs="1" sm="1">
                                                </v-col>
                                                <v-col cols="10" md="10" xs="10" sm="10">
                                                   <v-row>
                                                      <v-col cols="12" md="12" xs="12" sm="12">
                                                         <input :placeholder="$t('message.Entercodeorlink')" v-model="coppylink" type="text" class="input" style="border-radius: 20px;">
                                                      </v-col>
                                                      <v-col cols="2" md="2" xs="2" sm="2"></v-col>
                                                      <v-col cols="8" md="8" xs="8" sm="8">
                                                         <v-btn rounded block @click="submit" style="color: white" color="#3D85C6">
                                                            <v-icon>
                                                               mdi-video-plus-outline
                                                            </v-icon>
                                                            {{ $t("button.attendmeeting") }}
                                                         </v-btn>
                                                      </v-col>
                                                   </v-row>
                                                </v-col>
                                             </v-row>
                                          </v-card-text>

                                          <v-divider class="mt-n4"></v-divider>

                                          <v-card-actions>
                                             <v-spacer></v-spacer>
                                             <v-btn color="red" text @click="cancel">
                                                {{ $t("button.btncancel") }}
                                             </v-btn>
                                          </v-card-actions>
                                       </v-card>
                                    </v-dialog>
                                 </v-list>
                              </v-menu>
                              <v-menu v-if="roomexpired">
                                 <template v-slot:activator="{ on, attrs }">
                                    <v-btn block rounded class="white--text buttonMC" color="#BDBDBD" v-bind="attrs" v-on="on">
                                       <v-icon class="mr-2">mdi-video</v-icon>
                                       {{ $t("managepage.rooms") }}
                                    </v-btn>
                                 </template>
                                 <v-list>
                                    <v-dialog v-model="dialogA" width="500">
                                       <template v-slot:activator="{ on, attrs }">
                                          <v-list-item v-bind="attrs" v-on="on">
                                             <v-list-item-icon>
                                                <v-icon>mdi-video-plus-outline</v-icon>
                                             </v-list-item-icon>
                                             <v-list-item-title>{{ $t("loginpage.joinin") }}</v-list-item-title>
                                          </v-list-item>
                                       </template>
                                       <v-card>
                                          <v-card-title class="text-h5 grey lighten-2">
                                             {{ $t("joinpage.attendmeet") }}
                                          </v-card-title>

                                          <v-card-text>
                                             <v-row>
                                                <v-col cols="1" md="1" xs="1" sm="1">
                                                </v-col>
                                                <v-col cols="10" md="10" xs="10" sm="10">
                                                   <v-row>
                                                      <v-col cols="12" md="12" xs="12" sm="12">
                                                         <input :placeholder="$t('message.Entercodeorlink')" v-model="coppylink" type="text" class="input" style="border-radius: 20px;">
                                                      </v-col>
                                                      <v-col cols="2" md="2" xs="2" sm="2"></v-col>
                                                      <v-col cols="8" md="8" xs="8" sm="8">
                                                         <v-btn rounded block @click="submit" style="color: white" color="#3D85C6">
                                                            <v-icon>
                                                               mdi-video-plus-outline
                                                            </v-icon>
                                                            {{ $t("button.attendmeeting") }}
                                                         </v-btn>
                                                      </v-col>
                                                   </v-row>
                                                </v-col>
                                             </v-row>
                                          </v-card-text>

                                          <v-divider class="mt-n4"></v-divider>

                                          <v-card-actions>
                                             <v-spacer></v-spacer>
                                             <v-btn color="red" text @click="cancel">
                                                {{ $t("button.btncancel") }}
                                             </v-btn>
                                          </v-card-actions>
                                       </v-card>
                                    </v-dialog>
                                 </v-list>
                              </v-menu>
                              <!-- <v-tooltip bottom v-if="roomexpired">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                          block rounded class="white--text buttonMC"
                          color="#BDBDBD"
                          dark
                          v-bind="attrs"
                          v-on="{ ...tooltip, ...on }"
                        >
                        <v-icon class="mr-2">mdi-video</v-icon>
                        {{$t("managepage.rooms") }}
                        </v-btn>
                      </template>
                      <span>{{$t("managepage.roomsexpired") }}</span>
                </v-tooltip> -->
                           </v-col>
                           <v-col cols="4" md="6" xs="4" sm="4" v-if="chekjoin" class="mr-7">
                              <v-btn block rounded class="white--text buttonMC" color="#00BBAB" @click="backtojoin">
                                 <v-icon class="mr-2">mdi-application-export</v-icon>
                                 {{ $t("managepage.backrooms") }}
                              </v-btn>
                           </v-col>
                           <span class="pr-2"></span>
                           <v-col cols="5" md="5" xs="5" sm="5">
                              <v-menu v-if="roomexpired">
                                 <template v-slot:activator="{ on: menu, attrs }">
                                    <v-tooltip bottom>
                                       <template v-slot:activator="{ on: tooltip }">
                                          <v-btn block rounded class="white--text buttonMC" color="#BDBDBD" dark v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                                             <v-icon class="mr-2">mdi-calendar-multiselect</v-icon>
                                             {{ $t("managepage.schedule") }}
                                          </v-btn>
                                       </template>
                                       <span>{{ $t("managepage.roomsexpired") }}</span>
                                    </v-tooltip>
                                 </template>
                              </v-menu>
                              <v-btn block rounded class="white--text buttonMC" color="#FAAD14" @click="openModelScheduleSetting" v-if="!roomexpired">
                                 <v-icon class="mr-2">mdi-calendar-multiselect</v-icon>
                                 {{ $t("managepage.schedule") }}
                              </v-btn>
                           </v-col>
                           <span class="pr-2"></span>
                           <!-- <v-col cols="5" md="5" xs="5" sm="5">
                <v-btn rounded class="white--text buttonMC" color="#00D1A4" @click="openModelVote">
                  <Icon class="mr-2" icon="mdi:poll-box" width="24" />
                  ระบบโหวต
                </v-btn>
              </v-col> -->
                        </v-row>
                        <!-- <div class="ml-3 mt-4" style="font-size: 34px; font-weight: 500; line-height: 31.2px;">
              {{$t("loginpage.Mymeeting") }}
              </div> -->
                     </v-col>
                  </v-row>
               </v-col>
               <!-- <v-col cols="1" md="1" xs="1" sm="1"></v-col> -->
               <v-col cols="4" md="4" xs="4" sm="4" v-if="($vuetify.breakpoint.xl || $vuetify.breakpoint.lg)">
                  <v-img src="@/assets/Framemanege.png" max-width="80%" max-height="200px" class="mt-n16"></v-img>
               </v-col>
               <v-col cols="4" md="4" xs="4" sm="4" class="flex-end" v-if="($vuetify.breakpoint.md)">
                  <v-img src="@/assets/Framemanege.png" max-width="80%" max-height="200px"></v-img>
               </v-col>
            </v-row>
         </v-col>
         <!-- <v-col cols="1" md="1" xs="1" sm="1">
      </v-col> -->
         <v-row no-gutters>
            <v-col cols="1" md="1" xs="1" sm="1">
            </v-col>
            <v-col cols="10" md="10" xs="10" sm="10">
               <Schedue />
            </v-col>
            <v-col cols="1" md="1" xs="1" sm="1">
            </v-col>
         </v-row>
      </v-row>
      <v-row no-gutters class="mb-12" v-if="($vuetify.breakpoint.sm || $vuetify.breakpoint.xs)">
         <v-col cols="1" md="1" xs="1" sm="1">
         </v-col>
         <v-col cols="11" md="11" xs="11" sm="11">
            <v-row no-gutters>
               <!-- <v-col cols="2" md="2" xs="2" sm="2">
            <v-img
          src="@/assets/logoOne.png"
          max-width="87px"
          max-height="124.73px"
          class="float-right"
        ></v-img>
          </v-col> -->
               <!-- <v-col cols="10" md="10" xs="10" sm="10" class="mt-2">
            <div style="font-size: 34px; font-weight: 500; line-height: 44.2px;">
          ONE Conference
        </div>
        <div style="font-size: 18px; font-weight: 500; line-height: 31.2px;">
          Anywhere Anytime
        </div>
          </v-col> -->
               <!-- <v-col cols="1" md="1" xs="1" sm="1"></v-col> -->
               <!-- <v-col cols="4" md="4" xs="4" sm="4">
            <v-img src="@/assets/Framemanege.png" ></v-img>
          </v-col> -->
            </v-row>
            <!-- <v-row>
          <v-col cols="12" md="12" xs="12" sm="12">
            <v-img src="@/assets/Framemanege.png" ></v-img>
          </v-col>
        </v-row> -->
         </v-col>
         <v-row no-gutters class="mt-10">
            <v-col cols="1" md="1" xs="1" sm="1"></v-col>
            <v-col cols="10" md="10" xs="10" sm="10" v-if="!chekjoin">
               <div class="mb-3" style="font-size: 24px; font-weight: 500; line-height: 31.2px; text-align: center;">
                  {{ $t("loginpage.Mymeeting") }}
               </div>
               <v-menu v-if="roomexpired">
                  <template v-slot:activator="{ on, attrs }">
                     <v-btn block rounded class="white--text buttonMC" color="#BDBDBD" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-video</v-icon>
                        {{ $t("managepage.rooms") }}
                     </v-btn>
                  </template>
                  <v-list>
                     <v-dialog v-model="dialogA" width="500">
                        <template v-slot:activator="{ on, attrs }">
                           <v-list-item v-bind="attrs" v-on="on">
                              <v-list-item-icon>
                                 <v-icon>mdi-video-plus-outline</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>{{ $t("loginpage.joinin") }}</v-list-item-title>
                           </v-list-item>
                        </template>
                        <v-card>
                           <v-card-title class="text-h5 grey lighten-2">
                              {{ $t("joinpage.attendmeet") }}
                           </v-card-title>

                           <v-card-text>
                              <v-row>
                                 <v-col cols="1" md="1" xs="1" sm="1">
                                 </v-col>
                                 <v-col cols="10" md="10" xs="10" sm="10">
                                    <v-row>
                                       <v-col cols="12" md="12" xs="12" sm="12">
                                          <input :placeholder="$t('message.Entercodeorlink')" v-model="coppylink" type="text" class="input" style="border-radius: 20px;">
                                       </v-col>
                                       <v-col cols="2" md="2" xs="2" sm="2"></v-col>
                                       <v-col cols="8" md="8" xs="8" sm="8">
                                          <v-btn rounded block @click="submit" color="primary">
                                             <v-icon>
                                                mdi-video-plus-outline
                                             </v-icon>
                                             {{ $t("button.attendmeeting") }}
                                          </v-btn>
                                       </v-col>
                                    </v-row>
                                 </v-col>
                              </v-row>
                           </v-card-text>

                           <v-divider class="mt-n4"></v-divider>

                           <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="red" text @click="cancel">
                                 {{ $t("button.btncancel") }}
                              </v-btn>
                           </v-card-actions>
                        </v-card>
                     </v-dialog>
                  </v-list>
               </v-menu>
               <!-- <v-tooltip bottom v-if="roomexpired">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                          block rounded class="white--text buttonMC"
                          color="#BDBDBD"
                          dark
                          v-bind="attrs"
                          v-on="{ ...tooltip, ...on }"
                        >
                        <v-icon class="mr-2">mdi-video</v-icon>
                        {{$t("managepage.rooms") }}
                        </v-btn>
                      </template>
                      <span>{{$t("managepage.roomsexpired") }}</span>
                </v-tooltip> -->
               <v-menu offset-y v-if="!roomexpired">
                  <template v-slot:activator="{ on, attrs }">
                     <v-btn block rounded class="white--text buttonMC" color="#3D85C6" v-bind="attrs" v-on="on">
                        <v-icon class="mr-2">mdi-video</v-icon>
                        {{ $t("managepage.rooms") }}
                     </v-btn>
                  </template>
                  <v-list>
                     <v-list-item link @click="openModelRoomSetting">
                        <v-list-item-icon>
                           <v-icon>mdi-video</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ $t("managepage.rooms") }}</v-list-item-title>
                     </v-list-item>
                     <v-dialog v-model="dialogA" width="500">
                        <template v-slot:activator="{ on, attrs }">
                           <v-list-item v-bind="attrs" v-on="on">
                              <v-list-item-icon>
                                 <v-icon>mdi-video-plus-outline</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>{{ $t("loginpage.joinin") }}</v-list-item-title>
                           </v-list-item>
                        </template>
                        <v-card>
                           <v-card-title class="text-h5 grey lighten-2">
                              {{ $t("joinpage.attendmeet") }}
                           </v-card-title>

                           <v-card-text>
                              <v-row>
                                 <v-col cols="1" md="1" xs="1" sm="1" class="mb-4">
                                 </v-col>
                                 <v-col cols="10" md="10" xs="10" sm="10" class="mb-4">
                                    <v-row>
                                       <v-col cols="12" md="12" xs="12" sm="12">
                                          <input :placeholder="$t('message.Entercodeorlink')" v-model="coppylink" type="text" class="input" style="border-radius: 20px;">
                                       </v-col>
                                       <v-col cols="12" md="12" xs="12" sm="12">
                                          <v-btn rounded block @click="submit" color="primary">
                                             <v-icon>
                                                mdi-video-plus-outline
                                             </v-icon>
                                             {{ $t("button.attendmeeting") }}
                                          </v-btn>
                                       </v-col>
                                    </v-row>
                                 </v-col>
                              </v-row>
                           </v-card-text>

                           <v-divider class="mt-n6"></v-divider>

                           <v-card-actions>
                              <v-spacer></v-spacer>
                              <v-btn color="primary" text @click="cancel">
                                 {{ $t("button.btncancel") }}
                              </v-btn>
                           </v-card-actions>
                        </v-card>
                     </v-dialog>
                  </v-list>
               </v-menu>
            </v-col>
            <v-col cols="10" md="10" xs="10" sm="10" v-if="chekjoin">
               <v-btn block rounded class="white--text buttonMC" color="#00BBAB" @click="backtojoin">
                  <v-icon class="mr-2">mdi-application-import</v-icon>
                  {{ $t("managepage.backrooms") }}
               </v-btn>
            </v-col>
            <v-col cols="1" md="1" xs="1" sm="1"></v-col>
            <v-col cols="1" md="1" xs="1" sm="1"></v-col>
            <v-col cols="10" md="10" xs="10" sm="10" class="mt-2">
               <v-menu v-if="roomexpired">
                  <template v-slot:activator="{ on: menu, attrs }">
                     <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                           <v-btn block rounded class="white--text buttonMC" color="#BDBDBD" dark v-bind="attrs" v-on="{ ...tooltip, ...menu }">
                              <v-icon class="mr-2">mdi-calendar-multiselect</v-icon>
                              {{ $t("managepage.schedule") }}
                           </v-btn>
                        </template>
                        <span>{{ $t("managepage.roomsexpired") }}</span>
                     </v-tooltip>
                  </template>
               </v-menu>
               <v-btn block rounded class="white--text buttonMC" color="#FAAD14" @click="openModelScheduleSetting" v-if="!roomexpired">
                  <v-icon class="mr-2">mdi-calendar-multiselect</v-icon>
                  {{ $t("managepage.schedule") }}
               </v-btn>
            </v-col>
            <!-- <v-col cols="1" md="1" xs="1" sm="1"></v-col>
              <v-col cols="1" md="1" xs="1" sm="1"></v-col>
              <v-col cols="10" md="10" xs="10" sm="10" class="mt-2">
                <v-btn rounded block class="white--text buttonMC" color="#00D1A4" @click="openModelVote">
                  <Icon class="mr-2" icon="mdi:poll-box" width="24" />
                  ระบบโหวต
                </v-btn>
              </v-col> -->
            <v-col cols="1" md="1" xs="1" sm="1"></v-col>
         </v-row>
         <!-- <v-col cols="1" md="1" xs="1" sm="1">
      </v-col> -->
         <v-row no-gutters>
            <v-col cols="1" md="1" xs="1" sm="1">
            </v-col>
            <v-col cols="10" md="10" xs="10" sm="10">
               <Schedue />
            </v-col>
            <v-col cols="1" md="1" xs="1" sm="1">
            </v-col>
         </v-row>
      </v-row>
      <Roomsetting />
      <schedulesetting />
   </v-row>
</template>
<script>
import Upper from '../upper'
import Roomsetting from '../dialog/roomsetting.vue'
import schedulesetting from '../dialog/schedulesetting.vue'
import Schedue from '../manage/schedule'
import { mapActions, mapState } from 'vuex'
// import { Icon } from '@iconify/vue2'
export default {
   components: {
      Upper,
      Schedue,
      Roomsetting,
      schedulesetting
      // Icon,
   },
   data() {
      return {
         jwt: require('jsonwebtoken'),
         chekjoin: false,
         roomexpired: false,
         blackroom: '',
         dialogA: false,
         coppylink: '',
      }
   },
   created() {
      if (localStorage.getItem('user-token') === null) {
         this.$router.push('/')
      } else {
         this.refrestoken()
         this.role = localStorage.getItem('user-token')
         this.decodejwttoken()
         // var roleEncrypt = localStorage.getItem('role')
         // const decryptedText = this.CryptoJS.AES.decrypt(
         //   roleEncrypt,
         //   'One Conference'
         // ).toString(this.CryptoJS.enc.Utf8)
         // this.role = decryptedText
      }
   },
   computed: {
      ...mapState('dialog', ['roomSetting'])
   },
   watch: {
      roomSetting(value, oldValue) {
         if (value !== oldValue && value === false) {
            this.decodejwttoken(localStorage.getItem('user-token'))
         }
      }
   },
   methods: {
      ...mapActions('dialog', [
         'setDialogRoomSetting',
         'setDialogScheduleSetting',
         'setDialogdataedit'
         // 'setVoteSystem'
      ]),
      openModelRoomSetting() {
         this.refrestoken()
         this.setDialogRoomSetting(true)
      },
      openModelScheduleSetting() {
         this.refrestoken()
         this.setDialogdataedit('')
         this.setDialogScheduleSetting(true)
      },
      // openModelVote() {
      //   this.setVoteSystem(true)
      // },
      async refrestoken() {
         var token = localStorage.getItem('user-token')
         await this.axios.get(process.env.VUE_APP_API + '/api/lv1/auth/refreshtoken',
            {
               headers: {
                  Authorization: "bearer " + localStorage.getItem('user-token'),
               },
            }
            // {
            //   headers: {
            //         Authorization: 'bearer ' + token
            //       }
            // }
         ).then(res => {
            // console.log('sssss', res)
            this.decodejwttoken()
            // this.checkExpire()
         }).catch(err => {
            this.$swal(this.$t("message.Sessiontimeout"), '', 'warning').then(result => {
               localStorage.clear()
               localStorage.setItem("lang", "th")
               window.open('/', '_self')
            })
         })
      },
      checkjoin() {
         this.axios.get(process.env.VUE_APP_API + '/api/lv1/join/checksession').then(res => {
            if (res.data.result === 'Success') {
               // console.log('checksession', res.data.data)
               this.blackroom = res.data.data.uid
               this.chekjoin = res.data.data.session
            }
         })
            .catch(err => {
               console.log('opentobacklooby', err)
            })
         // this.$router.push({ path: '/backtolobbyHost' + '/?uuid=' + this.uuid, params: { schedule: 1 } }).catch(() => {})
      },
      checkExpire() {
         this.axios
            .get(process.env.VUE_APP_API + '/api/v1/code/checkExpire')
            .then(res => {
               if (res.data.result === 'expired') {
                  // console.log('sssss', res.data.result)
                  this.roomexpired = true
                  // console.log('sssss', this.roomexpired)
               } else if (res.data.result === 'Success') {
                  this.roomexpired = false
               } else {
                  this.$router.push('/joinpage')
               }
            })
            .catch(err => {
               console.log('err', err.message)
            })
      },
      backtojoin() {
         this.refrestoken()
         this.$router.push(`/backtolobbyHost?uuid=${this.blackroom}`)
      },
      submit() {
         // console.log('coppylink', this.coppylink)
         if (this.coppylink === '') {
            this.$swal(this.$t("message.Entercodeorlink") + this.$t("message.tryagain"), "", "warning");
         } else {
            let texturl = this.coppylink
            const myarr = texturl.split("?")
            if (myarr[1] === undefined) {
               const arry = myarr[0].split("=")
               if (arry[1] === undefined) {
                  // const arry2 = arry[0].split("-")
                  // if (arry2[3] === undefined) {
                  // this.$router.push('/join' + '/?uuid=' + arry + '&T=' + 1).catch(() => { })
                  // } else {
                  // const uuidlink = arry2[0] + "-" + arry2[1] + "-" + arry2[2] + arry2[3]
                  this.$router.push('/join' + '/?uuid=' + arry + '&T=' + 1).catch(() => { })
                  // }
               } else {
                  // const arry2 = arry[1].split("-")
                  // if (arry2[3] === undefined) {
                  this.$router.push('/join' + '/?uuid=' + arry[1] + '&T=' + 1).catch(() => { })
                  // } else {
                  //    const uuidlink = arry2[0] + "-" + arry2[1] + "-" + arry2[2] + arry2[3]
                  //    this.$router.push('/join' + '/?uuid=' + uuidlink + '&T=' + 1).catch(() => { })
                  // }
               }
            } else {
               const idtest = new URL(this.coppylink).searchParams.get('uuid')
               this.$router.push('/join' + '/?uuid=' + idtest + '&T=' + 1).catch(() => { })
            }
         }
      },
      cancel() {
         this.dialogA = false
         this.coppylink = ''
      },
      decodejwttoken() {
         var token = localStorage.getItem('user-token')
         const decryptedText = this.CryptoJS.AES.decrypt(
            token,
            process.env.VUE_APP_SECRET_KEY
         )
            .toString(this.CryptoJS.enc.Utf8)
            .replace(/"/g, '')
         var data = this.jwt.decode(decryptedText)
         this.userData = data
         // console.log('this.userData', this.userData)
         this.checkjoin()
      },
   }
}
</script>
<style scoped>
.backgroundmanage {
   background-image: url("~@/assets/Framemanege.png");
   height: 100%;
   width: 100%;
   /* background-position: right;
    transform: translate(1px, 0px);
    height: 100%;
    width: 100%; */
   /* left: 100%; */
   /* background-repeat: no-repeat; */
   /* background-size: cover; */
}

@media screen and (max-width: 900px) {
   .background {
      display: none;
   }
}

.input-container {
   position: relative;
   display: flex;
   width: 100%;
   max-width: 485px;
   height: 38px;
}

.input-container>span,
.input-container .input {
   white-space: nowrap;
   display: block;
}

.input-container>span,
.input-container .input:first-child {
   border-radius: 6px 0 0 6px;
}

.input-container>span,
.input-container .input {
   border-radius: 0 6px 6px 0;
}

.input-container>span,
.input-container .input {
   margin-left: -1px;
}

.input-container .input {
   position: relative;
   z-index: 1;
   flex: 1 1 auto;
   width: 1%;
   margin-top: 0;
   margin-bottom: 0;
}

.input-container span {
   text-align: center;
   padding: 8px 12px;
   font-size: 14px;
   line-height: 25px;
   color: #ffffff;
   background: #0043df;
   border: 1px solid #CDD9ED;
   font-weight: bold;
   transition: background 0.3s ease, border 0.3s ease, color 0.3s ease;
}

.input-container:focus-within>span {
   color: #fff;
   background-color: #0c90e296;
   border-color: #148cd1;
}

.input {
   display: block;
   width: 100%;
   padding: 8px 16px;
   line-height: 25px;
   font-size: 14px;
   font-weight: 500;
   font-family: inherit;
   border-radius: 6px;
   -webkit-appearance: none;
   color: #99A3BA;
   border: 1px solid #CDD9ED;
   background: #fff;
   transition: border 0.3s ease;
}

.input::placeholder {
   color: #CBD1DC;
}

.input:focus {
   outline: none;
   border-color: #148cd1;
}
</style>
